export const RuLocale = {
  translation: {
    Hello: 'Привет',
    'Created with': 'Создано с',
    Create: 'Создать',
    'Save order': 'Сохранить порядок',
    orderUpdated: 'Порядок успешно обновлен',
    'by IntexSoft': 'в IntexSoft',
    'Signing in...': 'Вход в аккаунт...',
    'Preparation for work...': 'Подготовка к работе...',
    'Page not found': 'Страница не найдена',
    'Page in developing': 'Страница в разработке',
    'Module in developing': 'Модуль в разработке',
    'Open list': 'Показать список',
    'Add new': 'Добавить новое',
    Add: 'Добавить',
    'Network error': 'Нет связи с сервером!',
    'Access denied': 'Доступ запрещен!',
    'You are denied access to this system!':
      'Вам запрещен доступ к данной системе!',
    'Request access': 'Запросить доступ',
    'Attempt to restore communication with the server...':
      'Попытка восстановления связи с сервером...',
    'No result': 'Нет результатов',
    'Not assign': 'Не задано',
    'Unknown status': 'Неизвестный статус',
    'Edit record': 'Редактировать запись',
    'Edit tags': 'Редактировать теги',

    Loading: 'Загрузка',
    Contacts: 'Контакты',
    Information: 'Информация',
    'Search keywords': 'Поиск по ключевым словам',
    'Search name, surname, phone, email':
      'Поиск по имени, фамилии, телефону, email',
    'Region is not set': 'Регион не задан',
    'New record': 'Новая запись',
    'New person': 'Новый кандидат',
    'Add vacancies for HR': 'Добавить вакансию для HR',
    'Number of people': 'Количество людей',
    'Edit person': 'Редактировать кандидата',
    'Duplicate record': 'Дублировать запись',
    'New widget': 'Новый виджет',
    'New internship': 'Новая групповая стажировка',
    Attention: 'Внимание',
    Internship: 'Групповая стажировка',
    Total: 'Всего',
    Date: 'Дата',
    Time: 'Время',
    Today: 'Сегодня',
    'Full Name': 'Полное имя',
    Jobs: 'Вакансия(-и)',
    'Job type': 'Вид занятости',
    Remote: 'Частичная занятость',
    'Full time': 'Полная занятость',
    'Last name': 'Фамилия',
    'First name': 'Имя',
    Experience: 'Опыт работы в годах',
    'English level': 'Уровень английского',
    Favourites: 'Избранные',
    Email: 'Почта',
    Phone: 'Телефон',
    LINKEDIN: 'Linkedin',
    TELEGRAM: 'Telegram',
    OFFER: 'Оффер',
    MS_TEAMS: 'Microsoft Teams',
    Offer: 'Оффер',
    'Upload file': 'Загрузка файла',
    Status: 'Статус',
    Dashboard: 'Информационная панель',
    profile: 'Профиль',
    'Search regions': 'Поиск регионов',
    'Search hrs': 'Поиск HR',
    'Search candidates': 'Поиск кандидатов',
    'Search vacancies': 'Поиск вакансий',
    'Search statuses': 'Поиск статусов',
    'Search sources': 'Поиск источников',
    'Search tags': 'Поиск тегов',
    'List of vacancies': 'Список вакансий',
    'Search internship-statuses': 'Поиск статусов',
    Candidates: 'Кандидаты',
    Candidate: 'Кандидат',
    'Control panel': 'Панель управления',
    Archive: 'Архив',
    Report: 'Отчет',
    Reports: 'Отчеты',
    'My report': 'Мой отчет',
    'HR & Vacancies': 'HR и Вакансии',
    'Edit vacancies for HR': 'Изменение вакансий для HR',
    'Comment on the vacancy': 'Комментарий к вакансии',
    Internships: 'Стажировки',
    'Group internships': 'Групповые стажировки',
    Events: 'События',
    Help: 'Помощь',
    Hr: 'HR',
    Participant: 'Участник',
    'New Meet': 'Создать встречу',
    Recruiter: 'Рекрутер',
    'Tech specialist': 'Тех. специалист',
    'Tech specialist(-s)': 'Тех. специалист(-ы)',
    TechSpecialistEditableInInternship:
      'Измените технического специалиста в стажировке',
    Tags: 'Теги',
    Description: 'Описание',
    Referral: 'Реферер',
    Salary: 'Минимальный уровень желаемой ЗП (USD) чистыми',
    SalaryBrutto: 'Минимальный уровень желаемой ЗП (USD) brutto',
    Source: 'Источник',
    Region: 'Регион',
    Regions: 'Регионы',
    'Choose regions': 'Выберите регион(-ы)',
    'Choose tags': 'Выберите тег(-и)',
    Department: 'Отдел',
    Result: 'Результат',
    Comment: 'Комментарий',
    Comments: 'Комментарии',
    'Show results': 'Показать результаты',
    Reset: 'Сбросить фильтр',
    Yes: 'Да',
    No: 'Нет',
    'Add attachment': 'Добавить приложение',
    'Add external link': 'Добавить внешнюю ссылку',
    'Add tag': 'Добавить тег',
    Next: 'Далее',
    Merge: 'Объединить',
    Unmerge: 'Не объединять',
    Back: 'Назад',
    Cancel: 'Отмена',
    Apply: 'Применить',
    Format: 'Формат',
    'Choose format': 'Выберите формат',
    'Turn on': 'Включить',
    'Not now': 'Не сейчас',
    'Choose date': 'Выберите дату',
    'Choose date range': 'Выберите диапазон дат',
    'Choose jobs': 'Выберите вакансию',
    'Choose mentors': 'Выберите ментора',
    'All records': 'Все записи',
    'Last record': 'Последняя запись',
    'Open candidate': 'Открыть кандидата',
    'Eliminate candidate': 'Исключить кандидата',
    'Open in new tab': 'Открыть в новой вкладке',
    'Open internship': 'Открыть стажировку',
    Assistant: 'ИИ ассистент',
    'made changes': 'внес(-ла) изменения',
    'The employee initiated the merger of two candidates!':
      'Сотрудник инициировал слияние двух кандидатов!',
    'Choose job(-s)': 'Выберите вакансию(-ии)',
    'Choose job': 'Выберите вакансию',
    'Choose job type': 'Выберите вид занятости',
    'Choose status': 'Выберите статус',
    'Choose source': 'Выберите источник',
    'Choose HR': 'Выберите HR',
    'Choose recruiter': 'Выберите рекрутера',
    'Choose tech specialist': 'Выберите тех.специалиста',
    'Choose tech specialists': 'Выберите тех.специалистов',
    'Choose referral': 'Выберите реферера',
    'Choose region': 'Выберите регион',
    'Choose department': 'Выберите отдел',
    'Choose type': 'Выберите тип',
    'Choose experience': 'Выберите опыт',
    'Choose english level': 'Выберите уровень английского',
    'Choose second group': 'Выберите второй уровень группировки',
    'Choose tag(-s)': 'Выберите тег(-и)',
    'Enter title': 'Введите название',
    'Enter salary': 'Введите зарплатные ожидания',
    'Enter link': 'Введите ссылку',
    'Enter first name': 'Введите Имя',
    'Enter last name': 'Введите Фамилию',
    'Enter email': 'Введите Email',
    'Enter phone': 'Введите Телефон',
    'Enter offer': 'Введите оффер',
    'Person Records': 'Личное дело',
    'Show record history': 'Показывать историю изменений',
    'Display record history': 'Показать историю изменений',
    'Hide record history': 'Скрыть историю изменений',
    'This is system item, some fields can not be changed':
      'Это системный статус, некоторые поля изменить нельзя.',
    'This is system source, field can not be changed':
      'Это системный источник, поле изменить нельзя.',
    Job_type: 'Вид занятости',
    Attachments: 'Приложения',
    'External links': 'Внешние ссылки',
    'External link': 'Внешняя ссылка',
    'Enter external link': 'Введите внешнюю ссылку',
    Type: 'Тип',
    Storage: 'Хранилище',
    Author: 'Автор',
    Resume: 'Резюме',
    Document: 'Документ',
    Picture: 'Изображение',
    Other: 'Другое',
    Open: 'Открыть',
    Delete: 'Удалить',
    Warning: 'Внимание',
    Alert: 'Оповещение',
    Info: 'Информация',
    Error: 'Ошибка',
    Close: 'Закрыть',
    Send: 'Отправить',
    goToProfile: 'Перейти в профиль',
    Continue: 'Продолжить',
    In: 'в',
    More: 'Еще',
    'Record will be removed': 'Запись будет удалена',
    'Notification will be removed': 'Уведомление будет удалено',
    'Attachment will be removed': 'Приложение будет удалено',
    'External link will be removed': 'Внешняя ссылка будет удалена',
    'Internship will be removed': 'Вы действительно хотите удалить стажировку?',
    'Are you sure you want to delete internship?':
      'Внимание! Вся информация о прохождении стажировки\nкандидатами будет удалена!',
    'Candidate will be removed from internship':
      'Вы действительно хотите удалить\nкандидата из стажировки?',
    'Are you sure you want to delete candidate from internship?':
      'Внимание! Вся информация о прохождении стажировки\nкандидатом будет удалена!',
    'Add candidate': 'Добавить кандидата',
    'Create candidate': 'Создать кандидата',
    alreadyAddedToInternship: 'Данный кандидат уже добавлен в стажировку',
    'Job will be removed': 'Вакансия будет удалена',
    'Are you sure you want to delete job?':
      'Вы уверены что хотите удалить вакансию?',
    Url: 'Ссылка',
    File: 'Файл',
    'Waiting save': 'Ожидание сохранения',
    'Waiting deletion': 'Ожидание удаления',
    'Available only to me': 'Доступен только мне',
    'Choose file': 'Выберите файл',
    'Candidate will be removed': 'Кандидат будет удален',
    'List of added candidates': 'Список добавленных кандидатов',
    Title: 'Название',
    Save: 'Сохранить',
    Edit: 'Редактировать',
    'Region management': 'Управление регионами',
    'HR management': 'Управление HR',
    'Candidates visible from date': 'Кандидаты доступны с даты',
    'All candidates are visible': 'Все кандидаты доступны',
    'Reset visibility restriction': 'Сбросить ограничение видимости',
    'HR will only see candidates created on or after the selected date. Older candidates will be hidden.':
      'HR будет видеть только кандидатов, созданных в выбранную дату или позже. Более ранние кандидаты будут скрыты.',
    'From {{date}}': 'с {{date}}',
    'Vacancy management': 'Управление вакансиями',
    'Status management': 'Управление статусами',
    'Source management': 'Управление источниками',
    'Tag management': 'Управление тегами',
    Notifications: 'Уведомления',
    'New notification': 'Новое уведомление',
    'No unread notifications': 'Нет непрочитанных уведомлений',
    'Date testing': 'Дата тестирования',
    'Date start': 'Дата начала',
    'Date end': 'Дата окончания',
    'Date all': 'Дата начала / окончания',
    Mentors: 'Ментор(-ы)',
    Filters: 'Фильтры',
    'Active candidates': 'Активные кандидаты',
    'Send invite': 'Отправить приглашение',
    Support: 'Тех. поддержка',
    'Log out': 'Выход',
    'Log out message': 'Вы уверены, что хотите выйти?',
    'Change region': 'Изменить регион',
    'Chosen region': 'Выбранный регион',
    'Selected region': 'Выбран регион',
    'Selected all regions': 'Выбраны все регионы',
    'Selected vacancy': 'Выбранная вакансия',
    'Group by': 'Группировать по',
    'Internship status management': 'Управление статусами стажировок',
    'internship-status name should be unique':
      'Название статуса должно быть уникальным',
    'region name should be unique': 'Название региона должно быть уникальным',
    'vacancy name should be unique': 'Название вакансии должно быть уникальным',
    'source name should be unique': 'Название источника должно быть уникальным',
    'tag name should be unique': 'Название источника должно быть уникальным',
    Records: 'Записи',
    'Chart type': 'Тип графика',
    'Number of records': 'Количество записей',
    Legend: 'Легенда',
    Message: 'Текст сообщения',
    'Send message': 'Отправить сообщение',
    useTextTemplate: 'Использовать шаблон текста',
    variablesAdding: 'Добавление переменных',
    autoReplies: 'Автоответы',
    correspondence: 'Переписка',
    preliminaryInterview: 'Предварительное интервью',
    interview: 'Интервью',
    templatesForAutomaticReplies:
      'Шаблоны автоответов на почту кандидата, если был установлен статус «Отказ»',
    checkVariablesFormat: 'Проверьте формат переменных',
    candidateName: 'Имя кандидата',
    senderName: 'Имя отправителя',
    interviewDefaultTemplate:
      '{% CANDIDATE_FULL_NAME %}, добрый день! Это {% ME_FULL_NAME %}, HR менеджер компании IntexSoft. Хочу сообщить, что на данный момент, к сожалению, мы не можем предложить Вам работу/стажировку. Спасибо за проявленный интерес и уделенное нам время! Желаю Вам удачи в поисках. Хорошего дня!',
    chart_type: {
      bar: 'Столбчатый',
      donut: 'Кольцевой',
      horizontal: 'Горизонтальный',
    },
    attach: {
      modalTitle: 'Здесь вы можете прикрепить файлы к записи',
      modalNew: 'Новое приложение',
      modalEdit: 'Редактирование приложения',
    },
    personDuplicate: {
      title: 'Обнаружен дубликат',
      notSelected: 'Не выбрано',
      duplicateWarningText:
        'Нельзя создать кандидата с одинаковыми почтами, телефонами или ссылками',
    },
    personLink: {
      modalTitle: 'Здесь вы можете прикрепить внешние ссылки к кандидату',
      modalNew: 'Новая ссылка',
      modalEdit: 'Редактирование ссылки',
    },
    header: {
      tabs: {
        candidates: {
          base: 'База',
          communication: 'Диалог',
          requests: 'Заявки',
          wait: 'В ожидании',
          other: 'Прочие',
          archive: 'Архив',
        },
        internships: {
          wait: 'В ожидании',
          work: 'В работе',
          closed: 'Закрытые',
        },
        report: {
          job: 'Вакансия',
          hr: 'HR',
          recruiter: 'Рекрутер',
          status: 'Статус',
          source: 'Источник',
          region: 'Регион',
          experience: 'Опыт',
        },
      },
    },
    assistant: {
      placeholder: 'Задайте вопрос о кандидатах...',
      thinking: 'Ищу подходящие резюме...',
      welcome:
        'Спросите ассистента о кандидатах, навыках или опыте — он подберёт релевантные резюме.',
      emptyCandidates: 'Релевантные резюме не найдены',
      matchScore: 'Совпадение',
      experience: 'Опыт',
      year: 'год',
      yearsFew: 'года',
      years: 'лет',
      skills: 'Навыки',
      achievements: 'Достижения',
      evaluation: 'Оценка',
      showDetails: 'Показать детали',
      hideDetails: 'Скрыть детали',
      openCandidate: 'Открыть карточку',
      openInAssistant: 'Открыть в ассистенте',
      miniChatTitle: 'Подбор кандидатов',
      miniChatToggle: 'ИИ подбор',
      miniChatWelcome:
        'Напишите, кого ищете — получите имя, фамилию и проценты совпадения. Карточка откроет кандидата, ассистент — полное саммари.',
      miniChatFound: 'Найдено кандидатов: {{count}}',
      miniChatMore: 'Ещё {{count}} в ассистенте',
      readyToast: 'Сообщение обработано',
      readyOpenMiniChat: 'Открыть мини-чат',
      readyOpenAssistant: 'Открыть ассистента',
      deleteMessage: 'Удалить сообщение',
      deleteMessageConfirm: 'Сообщение будет удалено',
      deleteError: 'Не удалось удалить сообщение',
      clearAll: 'Очистить всё',
      clearAllConfirm: 'Вся история чата будет удалена',
      clearAllError: 'Не удалось очистить историю чата',
      error: 'Не удалось получить ответ. Попробуйте позже.',
      validationError: 'Некорректный запрос',
    },
    months: {
      January: 'Январь',
      February: 'Ферваль',
      March: 'Март',
      April: 'Апрель',
      May: 'Май',
      June: 'Июнь',
      July: 'Июль',
      August: 'Август',
      September: 'Сентябрь',
      October: 'Октябрь',
      November: 'Ноябрь',
      December: 'Декабрь',
    },
    notifications: {
      modal: {
        'Turn on Notifications': 'Включить уведомления',
        'Get notifications when you have new events or important dates you may have missed.':
          'Получайте уведомления о событиях или важных датах, которые вы могли бы пропустить.',
      },
      toast: {
        loading: 'Подключение к WS',
        success: 'WS подключен!',
        error: 'Ошибка подключения к WS!',
        enabled: 'Уведомления подключены!',
        error_enabling: 'Ошибка при включении уведомлений',
      },
      types: {
        GENERAL_TYPE: 'Общее уведомление',
        PERSON_RECORD_FEEDBACK_TYPE: 'Обратная связь',
        PERSON_RECORD_RE_CONTACT_TYPE: 'Повторно связаться',
        UPCOMING_INTERVIEW_TYPE: 'Собеседование',
      },
    },
    invitationToast: {
      'Copy invitation link': 'Скопировать ссылку приглашения',
      'Invitation link copied': 'Ссылка на приглашение скопирована',
      'Failed to copy invitation link':
        'Не удалось скопировать ссылку на приглашение',
    },
    validation: {
      unknownFormat: 'Ошибка в формате поля!',
      phone: 'Цифры 0-9, минимум 7 цифр, максимум 25',
      email: 'Ошибка в email. Перепроверьте!',
      confirmEmail: 'Подтвердите email',
      telegram: 'Ошибка в нике или телефоне пользователя Telegram!',
      url: 'Неправильный URL. Перепроверьте!',
      minLength: 'Минимальная длина',
      maxLength: 'Максимальная длина',
      fieldRequiredEmpty: 'Это обязательное поле. Оно не может быть пустым!',
      symbols: {
        one: 'символ',
        many: 'символа',
        others: 'символов',
      },
      maxFileSize: 'Файл превышает максимальный размер: {{maxFileSize}} Mb',
      wrongFileType: 'Некорректный формат файла',
      numbersOnly: 'Некорректный формат. Поле принимает только цифры',
    },
    userBadge: {
      unavailable: {
        fullName: 'Сотрудник недоступен',
      },
    },
    weekdays: {
      'Mo.': 'Пн',
      'Tu.': 'Вт',
      'We.': 'Ср',
      'Th.': 'Чт',
      'Fr.': 'Пт',
      'Sa.': 'Сб',
      'Su.': 'Вс',
    },
    internship: {
      format: {
        ONLINE: 'Онлайн',
        OFFLINE: 'Оффлайн',
      },
    },
    controlModal: {
      region: {
        'New region': 'Новый регион',
        'Edit region': 'Изменение региона',

        'Do you really want to delete region?':
          'Вы действительно хотите удалить регион?',
        'Attention! This region will be hidden, if it needs to be restored or completely deleted, contact support!':
          'Внимание! Данный регион будет скрыт, в случае необходимости его восстановления или полного удаления обратитесь в поддержку!',
        'Attention! This candidate was found in the partner companys system':
          'Внимание! Данный кандидат обнаружен в системе партнерской компании. Некоторые записи в карточке не будут доступны для вас.\n' +
          'Для получения более подробной информации о кандидате свяжитесь с Карпович Екатериной.',
      },
      hr: {
        'Edit hr': 'Изменение регионов для HR',
        'Selected hr': ' HR',
        'Do you really want to delete hr?':
          'Вы действительно хотите удалить следующий(ие) регион(ы) у этого HR?',
        'List of regions': 'Список регионов',
        'Choose regions': 'Выберите регионы',
      },
      vacancy: {
        'New vacancy': 'Новая вакансия',
        'Edit vacancy': 'Изменение вакансии',

        'Do you really want to delete vacancy?':
          'Вы действительно хотите удалить вакансию?',
        'Attention! This vacancy will be hidden, if it needs to be restored or completely deleted, contact support!':
          'Внимание! Данная вакансия будет скрыта, в случае необходимости ее восстановления или полного удаления обратитесь в поддержку!',
      },
      status: {
        'New status': 'Новый статус',
        'Edit status': 'Изменение статуса',
        'Do you really want to delete status?':
          'Вы действительно хотите удалить статус?',
        'Attention! This status will be hidden, if it needs to be restored or completely deleted, contact support!':
          'Внимание! Данный статус будет скрыт, в случае необходимости его восстановления или полного удаления обратитесь в поддержку!',
      },
      'internship-status': {
        'New internship-status': 'Новый статус',
        'Edit internship-status': 'Изменение статуса',
        'Do you really want to delete internship-status?':
          'Вы действительно хотите удалить статус стажировки?',
        'Attention! This internship-status will be hidden, if it needs to be restored or completely deleted, contact support!':
          'Внимание! Данный статус будет скрыт, в случае необходимости его восстановления или полного удаления обратитесь в поддержку!',
      },
      source: {
        'New source': 'Новый источник',
        'Edit source': 'Изменение источника',
        'Do you really want to delete source?':
          'Вы действительно хотите удалить источник?',
        'Attention! This source will be hidden, if it needs to be restored or completely deleted, contact support!':
          'Внимание! Данный источник будет скрыт, в случае необходимости его восстановления или полного удаления обратитесь в поддержку!',
      },
      tag: {
        'New tag': 'Новый тег',
        'Edit tag': 'Изменение тега',
        'Do you really want to delete tag?':
          'Вы действительно хотите удалить тег?',
        'Attention! This tag will be hidden, if it needs to be restored or completely deleted, contact support!':
          'Внимание! Данный тег будет скрыт, в случае необходимости его восстановления или полного удаления обратитесь в поддержку!',
      },
    },
    'Delete confirmation': 'Подтверждение удаления',
    Duplicate: 'Дубликат',
    'Such a record already exists!': 'Такая запись уже существует!',
    'Such a region already exists!':
      'Такой регион уже существует! Обратитесь в службу поддержки для восстановления.',
    'Such a status already exists in this group!':
      'Название статуса внутри группы должно быть уникальным!',
    'Do you really want to remove the next vacancy from this HR?':
      'Вы действительно хотите удалить следующую(ие) вакансию(ии) у этого HR?',
    'Main group': 'Главная группа',
    'Choose main group': 'Выберите главную группу',
    Color: 'Цвет',
    statusColor: {
      red: 'красный',
      orange: 'оранжевый',
      blue: 'синий',
      violet: 'фиолетовый',
      green: 'зелёный',
      grey: 'серый',
      black: 'чёрный',
      white: 'белый',
    },
    'Choose color': 'Выберите цвет',
    Preview: 'Пример отображения',
    'Maximum number of applications:':
      'Максимальное количество приложений: {{max}}',
    'Maximum number of links:': 'Максимальное количество ссылок: {{max}}',
    goToProfileHint: 'Двойной клик - перейти в профиль',
    openPreviewHint: 'Один клик - открыть предпросмотр',
    addToInternshipHint: 'Двойной клик - добавить в стажировку',
    answerToCandidate: 'Ответ кандидату',
    templateTextCanBeChangedInProfile:
      'Текст сообщения можно поменять в настройках вашего профиля',
    youWillBeRedirectedToYourEmailClient:
      'Вы будете перенаправлены на ваш почтовый клиент',
    sendEmail: 'Отправить письмо',
    templateLengthExceeded: 'Превышен лимит шаблона',
    fieldCannotBeEmpty: 'Поле не может быть пустым',
    loadMore: 'Загрузить ещё',
    markAllAsRead: 'Пометить все как прочитанное',
    deleteAllReadNotifications: 'Удалить все прочитанные нотификации',
    candidateLastRecordWillBeRemoved:
      'Вы действительно хотите удалить запись? Внимание! Кандидат также будет удален',
    system: 'Система',
    importUsers: 'Импортировать пользователей',
    cannotDeleteUserStatusInUse:
      'Нельзя удалить статус, так как он указан в записях кандидата',
    cannotDeleteInternshipStatusInUse:
      'Нельзя удалить статус, так как он указан в стажировках',
    enterNameSurnamePhoneEmail: 'Введите имя, фамилию, телефон или email',
    usersSuccessfullyImported: 'Пользователи успешно импортированы',
    importError: 'Ошибка импорта',
    or: '"или"',
    and: '"и"',
    enterKeywordsByComma: 'Ключевые слова, через запятую',
    searchByCV: 'Поиск по резюме',
    googleDriveUnavailable: 'Google Drive API недоступен, попробуйте позже',
    calendarEvent: {
      title: 'Создать приглашение в Google Calendar',
      editTitle: 'Изменить приглашение в Google Calendar',
      defaultSummary: 'Интервью',
      summary: 'Название события',
      startAt: 'Начало',
      endAt: 'Окончание',
      timeZone: 'Часовой пояс',
      participants: 'Участники',
      noParticipants: 'Нет участников',
      addMeetLink: 'Добавить ссылку Google Meet',
      description: 'Описание',
      create: 'Создать приглашение',
      save: 'Сохранить изменения',
      decline: 'Отклонить',
      edit: 'Изменить',
      delete: 'Удалить',
      openMeet: 'Открыть Google Meet',
      deleteConfirm: 'Вы уверены, что хотите отменить встречу?',
      successMessage: 'Приглашение в Google Calendar успешно создано',
      updateSuccessMessage: 'Приглашение в Google Calendar успешно изменено',
      deleteSuccessMessage: 'Встреча успешно отменена',
      errorMessage: 'Ошибка при создании приглашения',
      updateErrorMessage: 'Ошибка при изменении приглашения',
      deleteErrorMessage: 'Ошибка при отмене встречи',
      loadErrorMessage: 'Не удалось загрузить данные встречи',
      addParticipantByEmail: 'Пригласить участника',
      addParticipantButton: 'Добавить',
      cvSelectionChanged:
        'Одно из выбранных резюме больше недоступно. Сбросьте выбор и выберите доступные CV.',
      resetCvSelection: 'Сбросить выбор CV',
      existingCvHint:
        'Выберите CV, чтобы заменить вложения встречи. Если ничего не выбрано, текущие вложения сохранятся.',
      loadingCvs: 'Загружаем резюме кандидата...',
      downloadCv: 'Скачать CV',
      cvDownloading: 'Скачиваем…',
      cvDownloadError: 'Не удалось скачать CV. Попробуйте ещё раз.',
      cvAudienceHint:
        'Резюме добавляется к событию как ссылка на Google Drive, а не отдельный файл в письме. Выбирайте версию для всех участников, включая кандидата.',
      cvPendingHint:
        'Сохраните выбранный файл или отмените его выбор перед отправкой приглашения.',
      attachCv: 'Прикрепить резюме',
      noCloudCv: 'Нет доступных файлов резюме. Можно загрузить CV ниже.',
      uploadCv: 'Загрузить CV',
      uploadCvHint:
        'Сохраните выбранный файл, чтобы добавить его в список резюме. Он останется в приложениях кандидата, даже если отменить приглашение.',
      uploading: 'Загружаем...',
      uploadError: 'Не удалось сохранить CV. Попробуйте снова.',
      errors: {
        techMissing: 'В карточке кандидата отсутствует тех. специалист',
        hrMissing: 'В карточке кандидата отсутствует hr специалист',
        candidateEmailMissing: 'В карточке кандидата не указан email адрес',
        emailMissing: 'Не указан email адрес',
        summaryRequired: 'Укажите название события',
        startInPast: 'Время начала не может быть в прошлом',
        endBeforeStart: 'Время окончания должно быть позже начала',
        candidateEmailInvalid: 'Укажите корректный email кандидата',
        participantsRequired:
          'Добавьте хотя бы одного участника с email (кроме кандидата)',
      },
    },
  },
};
